<hb-base-widget
  [dashboardWidget]="dashboardWidget"
  [sortable]="sortable"
  [showActions]="showActions"
  class="gauge"
  [showDataOption]="true"
  [widgetTableData]="dashboardWidget?.widget?.data?.TableData"
>
  <div class="row p-3">
    <div class="col">
      <p align="center">
        <canvas [id]="canvasId" class="chart gaugejs"  chart></canvas>
      </p>
      <div class="text-center h5" [innerHtml]="displayValue"></div>
    </div>
  </div>
</hb-base-widget>
